// SWOT view (components/SWOTAnalysis/SWOTView.jsx): the `swotView` namespace,
// in its own file so its strings grow here, not in fi.js / en.js / sv.js (#1420).
// Quadrant keys match the SWOT items' `quadrant`; view keys match VIEW_MODES.

export const swotViewFi = {
  quadrant: { strength: 'VAHVUUDET', weakness: 'HEIKKOUDET', opportunity: 'MAHDOLLISUUDET', threat: 'UHAT' },
  quadrantTitle: { strength: 'Vahvuudet', weakness: 'Heikkoudet', opportunity: 'Mahdollisuudet', threat: 'Uhat' },
  quadrantChip: { strength: '{{count}} vahvuus', weakness: '{{count}} heikkous', opportunity: '{{count}} mahd.', threat: '{{count}} uhka' },
  views: { grid: 'SWOT', pie: 'Piirakka', mood: 'Tunnelma', bar: 'Palkit', scatter: 'Hajonta', list: 'Lista' },
  axis: { negative: 'NEGATIIVINEN', positive: 'POSITIIVINEN', external: 'ULKOINEN', internal: 'SISÄINEN' },
  members: '{{title}} ({{count}} jäsentä)',
  optimism: {
    veryPositive: 'Erittäin positiivinen tulevaisuuskuva! Vahvuuksia ja mahdollisuuksia tunnistettu runsaasti.',
    optimistic: 'Varovaisen optimistinen näkymä. Mahdollisuuksia nähdään enemmän kuin uhkia.',
    balanced: 'Tasapainoinen näkemys. Sekä haasteita että mahdollisuuksia tunnistettu.',
    worried: 'Huolestuneisuutta ilmassa. Enemmän haasteita kuin mahdollisuuksia.',
    critical: 'Kriittinen tilanne. Paljon uhkia ja heikkouksia tunnistettu.',
  },
  mood: {
    noData: 'Ei dataa',
    veryPositive: 'Erittäin positiivinen',
    optimistic: 'Optimistinen',
    balanced: 'Tasapainoinen',
    worried: 'Huolestunut',
    critical: 'Kriittinen',
  },
  futureOptimism: 'Tulevaisuusoptimismi',
  positiveNegative: 'Positiiviset: {{positive}} | Negatiiviset: {{negative}}',
  votes: 'Osallistujien äänet',
  themes: 'teemaa',
  themeOne: 'teema',
  themeCount: '{{count}} teemaa',
  generalScenario: 'Yleinen',
  overallOptimism: 'Kokonaisoptimismi',
  summary: 'Työpajan osallistujat tunnistavat yhteensä {{total}} teemaa, joista {{positive}} on positiivisia (vahvuuksia ja mahdollisuuksia) ja {{negative}} on haasteita (heikkouksia ja uhkia).',
  mostOptimistic: 'Optimistisin skenaario on {{name}} ({{score}} %).',
  moodByScenario: 'Tunnelma skenaarioittain',
  barAxis: 'Sävy: Negatiivinen ← 0 → Positiivinen',
  scatterX: 'SÄVY (Negatiivinen → Positiivinen)',
  scatterY: 'TOIMIJUUS (Ulkoinen → Sisäinen)',
  list: { theme: 'Teema', quadrant: 'Luokka', sentiment: 'Sävy', agency: 'Toimijuus', members: 'Jäseniä' },
  scenarioModalLabel: '{{description}} - {{count}} teemaa',
  sentimentValue: 'Sävy: {{value}} %',
  memberCount: '{{count}} jäsentä',
  noThemes: 'Ei teemoja tässä skenaariossa.',
  analysis: 'Analyysi',
  sentiment: 'Sävy',
  agency: 'Toimijuus',
  examples: 'Esimerkkejä',
  scenarios: 'Skenaariot',
  membersLabel: 'Jäseniä:',
  participantsLabel: 'Osallistujia:',
  crossScenario: 'Moniskenaarioinen',
  refresh: 'Päivitä analyysi (ohita välimuisti)',
  analysing: 'Analysoidaan työpajadataa...',
  mayTakeAWhile: 'Tämä voi kestää hetken',
  networkError: 'Verkkovirhe - tarkista yhteys RAG-palveluun',
  retry: 'Yritä uudelleen',
};

export const swotViewEn = {
  quadrant: { strength: 'STRENGTHS', weakness: 'WEAKNESSES', opportunity: 'OPPORTUNITIES', threat: 'THREATS' },
  quadrantTitle: { strength: 'Strengths', weakness: 'Weaknesses', opportunity: 'Opportunities', threat: 'Threats' },
  quadrantChip: { strength: '{{count}} strength', weakness: '{{count}} weakness', opportunity: '{{count}} opp.', threat: '{{count}} threat' },
  views: { grid: 'SWOT', pie: 'Pie', mood: 'Mood', bar: 'Bars', scatter: 'Scatter', list: 'List' },
  axis: { negative: 'NEGATIVE', positive: 'POSITIVE', external: 'EXTERNAL', internal: 'INTERNAL' },
  members: '{{title}} ({{count}} members)',
  optimism: {
    veryPositive: 'A very positive view of the future! Many strengths and opportunities identified.',
    optimistic: 'A cautiously optimistic outlook. More opportunities are seen than threats.',
    balanced: 'A balanced view. Both challenges and opportunities identified.',
    worried: 'Worry in the air. More challenges than opportunities.',
    critical: 'A critical situation. Many threats and weaknesses identified.',
  },
  mood: {
    noData: 'No data',
    veryPositive: 'Very positive',
    optimistic: 'Optimistic',
    balanced: 'Balanced',
    worried: 'Worried',
    critical: 'Critical',
  },
  futureOptimism: 'Future optimism',
  positiveNegative: 'Positive: {{positive}} | Negative: {{negative}}',
  votes: 'Participants’ votes',
  themes: 'themes',
  themeOne: 'theme',
  themeCount: '{{count}} themes',
  generalScenario: 'General',
  overallOptimism: 'Overall optimism',
  summary: 'In total the workshop’s participants identify {{total}} themes, of which {{positive}} are positive (strengths and opportunities) and {{negative}} are challenges (weaknesses and threats).',
  mostOptimistic: 'The most optimistic scenario is {{name}} ({{score}} %).',
  moodByScenario: 'Mood by scenario',
  barAxis: 'Sentiment: Negative ← 0 → Positive',
  scatterX: 'SENTIMENT (Negative → Positive)',
  scatterY: 'AGENCY (External → Internal)',
  list: { theme: 'Theme', quadrant: 'Category', sentiment: 'Sentiment', agency: 'Agency', members: 'Members' },
  scenarioModalLabel: '{{description}} - {{count}} themes',
  sentimentValue: 'Sentiment: {{value}} %',
  memberCount: '{{count}} members',
  noThemes: 'No themes in this scenario.',
  analysis: 'Analysis',
  sentiment: 'Sentiment',
  agency: 'Agency',
  examples: 'Examples',
  scenarios: 'Scenarios',
  membersLabel: 'Members:',
  participantsLabel: 'Participants:',
  crossScenario: 'Across scenarios',
  refresh: 'Refresh the analysis (skip the cache)',
  analysing: 'Analysing the workshop data...',
  mayTakeAWhile: 'This may take a moment',
  networkError: 'Network error - check the connection to the RAG service',
  retry: 'Try again',
};

export const swotViewSv = {
  quadrant: { strength: 'STYRKOR', weakness: 'SVAGHETER', opportunity: 'MÖJLIGHETER', threat: 'HOT' },
  quadrantTitle: { strength: 'Styrkor', weakness: 'Svagheter', opportunity: 'Möjligheter', threat: 'Hot' },
  quadrantChip: { strength: '{{count}} styrka', weakness: '{{count}} svaghet', opportunity: '{{count}} möjl.', threat: '{{count}} hot' },
  views: { grid: 'SWOT', pie: 'Paj', mood: 'Stämning', bar: 'Staplar', scatter: 'Spridning', list: 'Lista' },
  axis: { negative: 'NEGATIV', positive: 'POSITIV', external: 'EXTERN', internal: 'INTERN' },
  members: '{{title}} ({{count}} medlemmar)',
  optimism: {
    veryPositive: 'En mycket positiv framtidsbild! Många styrkor och möjligheter har identifierats.',
    optimistic: 'En försiktigt optimistisk utsikt. Fler möjligheter än hot ses.',
    balanced: 'En balanserad syn. Både utmaningar och möjligheter har identifierats.',
    worried: 'Oro i luften. Fler utmaningar än möjligheter.',
    critical: 'Ett kritiskt läge. Många hot och svagheter har identifierats.',
  },
  mood: {
    noData: 'Inga data',
    veryPositive: 'Mycket positiv',
    optimistic: 'Optimistisk',
    balanced: 'Balanserad',
    worried: 'Orolig',
    critical: 'Kritisk',
  },
  futureOptimism: 'Framtidsoptimism',
  positiveNegative: 'Positiva: {{positive}} | Negativa: {{negative}}',
  votes: 'Deltagarnas röster',
  themes: 'teman',
  themeOne: 'tema',
  themeCount: '{{count}} teman',
  generalScenario: 'Allmänt',
  overallOptimism: 'Total optimism',
  summary: 'Workshopens deltagare identifierar sammanlagt {{total}} teman, av vilka {{positive}} är positiva (styrkor och möjligheter) och {{negative}} är utmaningar (svagheter och hot).',
  mostOptimistic: 'Det mest optimistiska scenariot är {{name}} ({{score}} %).',
  moodByScenario: 'Stämning per scenario',
  barAxis: 'Ton: Negativ ← 0 → Positiv',
  scatterX: 'TON (Negativ → Positiv)',
  scatterY: 'AKTÖRSKAP (Extern → Intern)',
  list: { theme: 'Tema', quadrant: 'Kategori', sentiment: 'Ton', agency: 'Aktörskap', members: 'Medlemmar' },
  scenarioModalLabel: '{{description}} - {{count}} teman',
  sentimentValue: 'Ton: {{value}} %',
  memberCount: '{{count}} medlemmar',
  noThemes: 'Inga teman i det här scenariot.',
  analysis: 'Analys',
  sentiment: 'Ton',
  agency: 'Aktörskap',
  examples: 'Exempel',
  scenarios: 'Scenarier',
  membersLabel: 'Medlemmar:',
  participantsLabel: 'Deltagare:',
  crossScenario: 'Över flera scenarier',
  refresh: 'Uppdatera analysen (hoppa över cachen)',
  analysing: 'Analyserar workshopdata...',
  mayTakeAWhile: 'Det här kan ta en stund',
  networkError: 'Nätverksfel - kontrollera anslutningen till RAG-tjänsten',
  retry: 'Försök igen',
};
